<template>
    <footer class="footer has-cards">
        <div class="container">

            <div class="row row-grid align-items-center my-md" v-if="
            this.domaineSlug !== 'circusmons' && this.domaineSlug !== 'gent' && this.domaineSlug !== 'niklaas'
            && this.domaineSlug !== 'lamaisondusquash'
            && this.domaineSlug !== 'montfoot5'
            && this.domaineSlug !== 'player63'
            && this.domaineSlug !== 'mksoccer'
            && this.domaineSlug !== 'msquash'
            && this.domaineSlug != 'allinacademy'
            && this.domaineSlug != 'jeudepaume'
            && this.domaineSlug != 'agora'
            ">
                <div class="col-lg-6">
                    <h3 class="text-primary font-weight-light mb-2">{{ $t('footer.doinsport.title') }}</h3>
                    <h4 class="mb-0 font-weight-light">{{ $t('footer.doinsport.content') }}</h4>
                </div>
                <div class="col-lg-6 text-lg-center btn-wrapper" >
                    <a :href="$t('footer.doinsport.ios')" target="_blank" class="mr-2"><img class="app-store-btn" src="img/app-store-icon.png" alt="App Store Icon"></a>
                    <a :href="$t('footer.doinsport.android')" target="_blank"><img class="google-play-btn" src="img/google-play-icon.png" alt="Google Play Icon"></a>
                </div>
            </div>

            <div class="row row-grid align-items-center my-md" v-if="this.domaineSlug === 'circusmons' || this.domaineSlug === 'gent' || this.domaineSlug === 'niklaas'">
                <div class="col-lg-6">
                    <h3 class="text-primary font-weight-light mb-2" style="color: red!important;">{{ $t('footer.circus.title') }}</h3>
                    <h4 class="mb-0 font-weight-light">{{ $t('footer.circus.content') }}</h4>
                </div>
                <div class="col-lg-6 text-lg-center btn-wrapper" >
                    <a :href="$t('footer.circus.ios')" target="_blank" class="mr-2"><img class="app-store-btn" src="img/app-store-icon.png" alt="App Store Icon"></a>
                    <a :href="$t('footer.circus.android')" target="_blank"><img class="google-play-btn" src="img/google-play-icon.png" alt="Google Play Icon"></a>
                </div>
            </div>

            <div class="row row-grid align-items-center my-md" v-if="this.domaineSlug === 'lamaisondusquash'">
                <div class="col-lg-6">
                    <h3 class="text-primary font-weight-light mb-2" style="color: red!important;">{{ $t('footer.lamaisondusquash.title') }}</h3>
                    <h4 class="mb-0 font-weight-light">{{ $t('footer.lamaisondusquash.content') }}</h4>
                </div>
                <div class="col-lg-6 text-lg-center btn-wrapper" >
                    <a :href="$t('footer.lamaisondusquash.ios')" target="_blank" class="mr-2"><img class="app-store-btn" src="img/app-store-icon.png" alt="App Store Icon"></a>
                    <a :href="$t('footer.lamaisondusquash.android')" target="_blank"><img class="google-play-btn" src="img/google-play-icon.png" alt="Google Play Icon"></a>
                </div>
            </div>

            <div class="row row-grid align-items-center my-md" v-if="this.domaineSlug === 'mksoccer'">
                <div class="col-lg-6">
                    <h3 class="text-primary font-weight-light mb-2" style="color: red!important;">{{ $t('footer.mksoccer.title') }}</h3>
                    <h4 class="mb-0 font-weight-light">{{ $t('footer.mksoccer.content') }}</h4>
                </div>
                <div class="col-lg-6 text-lg-center btn-wrapper" >
                    <a :href="$t('footer.mksoccer.ios')" target="_blank" class="mr-2"><img class="app-store-btn" src="img/app-store-icon.png" alt="App Store Icon"></a>
                    <a :href="$t('footer.mksoccer.android')" target="_blank"><img class="google-play-btn" src="img/google-play-icon.png" alt="Google Play Icon"></a>
                </div>
            </div>

            <div class="row row-grid align-items-center my-md" v-if="this.domaineSlug === 'player63'">
                <div class="col-lg-6">
                    <h3 class="text-primary font-weight-light mb-2" style="color: red!important;">{{ $t('footer.player63.title') }}</h3>
                    <h4 class="mb-0 font-weight-light">{{ $t('footer.player63.content') }}</h4>
                </div>
                <div class="col-lg-6 text-lg-center btn-wrapper" >
                    <a :href="$t('footer.player63.ios')" target="_blank" class="mr-2"><img class="app-store-btn" src="img/app-store-icon.png" alt="App Store Icon"></a>
                    <a :href="$t('footer.player63.android')" target="_blank"><img class="google-play-btn" src="img/google-play-icon.png" alt="Google Play Icon"></a>
                </div>
            </div>

            <div class="row row-grid align-items-center my-md" v-if="this.domaineSlug === 'montfoot5'">
                <div class="col-lg-6">
                    <h3 class="text-primary font-weight-light mb-2" style="color: red!important;">{{ $t('footer.montfoot5.title') }}</h3>
                    <h4 class="mb-0 font-weight-light">{{ $t('footer.montfoot5.content') }}</h4>
                </div>
                <div class="col-lg-6 text-lg-center btn-wrapper" >
                    <a :href="$t('footer.montfoot5.ios')" target="_blank" class="mr-2"><img class="app-store-btn" src="img/app-store-icon.png" alt="App Store Icon"></a>
                    <a :href="$t('footer.montfoot5.android')" target="_blank"><img class="google-play-btn" src="img/google-play-icon.png" alt="Google Play Icon"></a>
                </div>
            </div>

            <div class="row row-grid align-items-center my-md" v-if="this.domaineSlug === 'msquash'">
                <div class="col-lg-6">
                    <h3 class="text-primary font-weight-light mb-2" style="color: red!important;">{{ $t('footer.msquash.title') }}</h3>
                    <h4 class="mb-0 font-weight-light">{{ $t('footer.msquash.content') }}</h4>
                </div>
                <div class="col-lg-6 text-lg-center btn-wrapper" >
                    <a :href="$t('footer.msquash.ios')" target="_blank" class="mr-2"><img class="app-store-btn" src="img/app-store-icon.png" alt="App Store Icon"></a>
                    <a :href="$t('footer.msquash.android')" target="_blank"><img class="google-play-btn" src="img/google-play-icon.png" alt="Google Play Icon"></a>
                </div>
            </div>

            <div class="row row-grid align-items-center my-md" v-if="this.domaineSlug === 'allinacademy'">
                <div class="col-lg-6">
                    <h3 class="text-primary font-weight-light mb-2" style="color: red!important;">{{ $t('footer.allinacademy.title') }}</h3>
                    <h4 class="mb-0 font-weight-light">{{ $t('footer.allinacademy.content') }}</h4>
                </div>
                <div class="col-lg-6 text-lg-center btn-wrapper" >
                    <a :href="$t('footer.allinacademy.ios')" target="_blank" class="mr-2"><img class="app-store-btn" src="img/app-store-icon.png" alt="App Store Icon"></a>
                    <a :href="$t('footer.allinacademy.android')" target="_blank"><img class="google-play-btn" src="img/google-play-icon.png" alt="Google Play Icon"></a>
                </div>
            </div>

            <div class="row row-grid align-items-center my-md" v-if="this.domaineSlug === 'jeudepaume'">
              <div class="col-lg-6">
                <h3 class="text-primary font-weight-light mb-2" style="color: red!important;">{{ $t('footer.jeudepaume.title') }}</h3>
                <h4 class="mb-0 font-weight-light">{{ $t('footer.jeudepaume.content') }}</h4>
              </div>
              <div class="col-lg-6 text-lg-center btn-wrapper" >
                <a :href="$t('footer.jeudepaume.ios')" target="_blank" class="mr-2"><img class="app-store-btn" src="img/app-store-icon.png" alt="App Store Icon"></a>
                <a :href="$t('footer.jeudepaume.android')" target="_blank"><img class="google-play-btn" src="img/google-play-icon.png" alt="Google Play Icon"></a>
              </div>
            </div>

            <div class="row row-grid align-items-center my-md" v-if="this.domaineSlug === 'agora'">
              <div class="col-lg-6">
                <h3 class="text-primary font-weight-light mb-2" style="color: #4a9c5f!important;">{{ $t('footer.agora.title') }}</h3>
                <h4 class="mb-0 font-weight-light">{{ $t('footer.agora.content') }}</h4>
              </div>
              <div class="col-lg-6 text-lg-center btn-wrapper" >
                <a :href="$t('footer.agora.ios')" target="_blank" class="mr-2"><img class="app-store-btn" src="img/app-store-icon.png" alt="App Store Icon"></a>
                <a :href="$t('footer.agora.android')" target="_blank"><img class="google-play-btn" src="img/google-play-icon.png" alt="Google Play Icon"></a>
              </div>
            </div>

        </div>
    </footer>
</template>
<script>
export default {
  name: 'app-footer',
  data() {
    return {
      year: new Date().getFullYear(),
      domaineSlug: null,
    }
  },
  created() {
      var currentUrl = window.location.hostname;
      this.domaineSlug = currentUrl.split(".")[0];
  }
};
</script>
<style>
</style>
